import React from 'react';
import { toLocaleMoney } from '../../../shared/services/NumberService';

const ProdutoValoresDetalhePedido = ({ order = {} }) => {
  if (!order.products || order.products.length === 0) return null;

  return (
    <div className="dp-product-table">
      <div className="dp-product-table-header">
        <span>Produto</span>
        <span>Quantidade</span>
        <span>Marca</span>
        <span>Preço</span>
      </div>

      {order.products.map((product, index) => (
        <div key={index} className="dp-product-table-row">
          <span>{product.tipoDescricao}</span>
          <span>
            {product.quantidade} unidade{product.quantidade !== 1 ? 's' : ''}
          </span>
          <span>{product.marca?.nome}</span>
          <span>{toLocaleMoney(product.valor * product.quantidade)}</span>
        </div>
      ))}
    </div>
  );
};

export default ProdutoValoresDetalhePedido;
